module.exports = __webpack_public_path__ + "img/w3_link_black.8e7e7805.png";